
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'core/authentication.service';
import { NgSessionStorage, NgLocalStorage } from 'core/utils/ng-storage.service';
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProxyService {
    data: any;
    auditconfig: any;
    private currentRequests: number = 0;
    constructor(private http: HttpClient, public _auth: AuthenticationService, private ngLocalStorage: NgLocalStorage, private ngSessionStorage: NgSessionStorage, private _router: Router, private toastr: ToastrService) {
    }
    postData(url: string, data: any, isloading: boolean = true, currentUserName: boolean = true) {
        if (isloading) { this.incrementRequestCount() }
        let userDetail: any = this.ngLocalStorage.getItem('userDetail');
        let userName = JSON.parse(userDetail).UserName;
        let selectedPartner = JSON.parse(this.ngSessionStorage.getItem('selectedPartner'));
        let httpOptions = {
            'Content-Type': 'application/json',
        };
        if(currentUserName) {
            httpOptions['CurrentUserName'] = userName;
        }
        if(selectedPartner && selectedPartner.PartnerGUID) {
            httpOptions['PartnerGUID'] = selectedPartner.PartnerGUID;
        }
        if(selectedPartner && selectedPartner.SiteGUID) {
            httpOptions['SiteGUID'] = selectedPartner.SiteGUID;
        }
        return this.http.post(url, data, { headers: httpOptions }).pipe(
            map(response => { if (isloading) { this.decrementRequestCount(); } return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    postMultipartData(url: string, data: FormData, isloading: boolean = true) {
        if (isloading) { this.incrementRequestCount() }
        let userDetail: any = this.ngLocalStorage.getItem('userDetail');
        let userName = JSON.parse(userDetail).UserName;
        let selectedPartner = JSON.parse(this.ngSessionStorage.getItem('selectedPartner'));
        let httpOptions = {
            // 'Content-Type': 'form-data',
            'CurrentUserName': userName
        };
        if(selectedPartner && selectedPartner.PartnerGUID) {
            httpOptions['PartnerGUID'] = selectedPartner.PartnerGUID;
        }
        if(selectedPartner && selectedPartner.SiteGUID) {
            httpOptions['SiteGUID'] = selectedPartner.SiteGUID;
        }
        return this.http.post(url, data, { headers: httpOptions }).pipe(
            map(response => { if (isloading) { this.decrementRequestCount(); } return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    postNonJSONData(url: string, data: any, isloading: boolean = true) {
        if (isloading) { this.incrementRequestCount() }
        let userDetail: any = this.ngLocalStorage.getItem('userDetail');
        let userName = JSON.parse(userDetail).UserName;
        let selectedPartner = JSON.parse(this.ngSessionStorage.getItem('selectedPartner'));
        let httpOptions = {
            'Content-Type': 'text',
            'responseType': 'text',
            'CurrentUserName': userName
        };
        if(selectedPartner && selectedPartner.PartnerGUID) {
            httpOptions['PartnerGUID'] = selectedPartner.PartnerGUID;
        }
        if(selectedPartner && selectedPartner.SiteGUID) {
            httpOptions['SiteGUID'] = selectedPartner.SiteGUID;
        }
        return this.http.post(url, data, { headers: httpOptions }).pipe(
            map(response => { if (isloading) { this.decrementRequestCount(); } return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    postFileData(url: string, data: any, isloading: boolean = true) {
        if (isloading) { this.incrementRequestCount() }
        return this.http.post(url, data).pipe(
            map(response => { if (isloading) { this.decrementRequestCount(); } return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    post(url : string) {
        this.incrementRequestCount()
        let httpOptions = {
            'Content-Type': 'application/json',
        };
       return this.http.post(url, { headers: httpOptions }).pipe(
        map(response => { this.decrementRequestCount(); return response}),
        catchError((e: any)=>{
            return this.handleError(e)
        })
      );
    }
    
    postErrorData(url: string, data: any) {
        this.incrementRequestCount()
        let httpOptions = {
            'Content-Type': 'application/json'
        };
        let dataSend = data;
        return this.http.post(url, dataSend, { headers: httpOptions }).pipe(
            map(response => { this.decrementRequestCount(); return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    deleteData(url: string, data: any) {
        let userDetail: any = this.ngLocalStorage.getItem('userDetail');
        let userName = JSON.parse(userDetail).UserName;
        let selectedPartner = JSON.parse(this.ngSessionStorage.getItem('selectedPartner'));
        this.incrementRequestCount()
        let httpOptions = {
            'Content-Type': 'application/json',
            PartnerGUID: selectedPartner.PartnerGUID,
            PartnerSiteGUID: selectedPartner.SiteGUID,
            CurrentUserName: userName
        };
        return this.http.post(url, data, { headers: httpOptions }).pipe(
            map(response => { this.decrementRequestCount(); return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    putData(url: string, data: any) {
        this.incrementRequestCount();
        let userDetail: any = this.ngLocalStorage.getItem('userDetail');
        let userName = JSON.parse(userDetail).UserName;
        let selectedPartner = JSON.parse(this.ngSessionStorage.getItem('selectedPartner'));
        let httpOptions = {
            'Content-Type': 'application/json',
            'PartnerGUID': selectedPartner.PartnerGUID,
            'SiteGUID': selectedPartner.SiteGUID,
            'CurrentUserName': userName,
            'authorization': 'Bearer undefined'
        };
        let dataSend = data;
        return this.http.put(url, dataSend, { headers: httpOptions }).pipe(
            map(response => { this.decrementRequestCount(); return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    };

    proxyPostDownloadExcel(serviceURL: string, dataSend: any, fileName: string) {
        this.incrementRequestCount();
        return this.http.post(serviceURL, dataSend, {observe: 'response', responseType: 'blob'}).pipe(
            map((res: any) => { 
                this.decrementRequestCount(); 
                let data = {
                    image: new Blob([res.body], {type: res.headers.get('Content-Type')})
                 }
                return data ;
             }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    postDataOrDownload(serviceURL: string, dataSend: any) {
        this.incrementRequestCount();
        return this.http.post(serviceURL, dataSend, {observe: 'response', responseType: 'blob'}).pipe(
            map((res: any) => {
                this.decrementRequestCount();
                return res.body;
            }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    getData(url: string, isloading: boolean = true) {
        if (isloading) { this.incrementRequestCount() }
        let httpOptions = {
            'Content-Type': 'application/json'
        };
        return this.http.get(url, { headers: httpOptions }).pipe(
            map(response => { if (isloading) { this.decrementRequestCount(); } return response }),
            catchError((e: any) => {
                return this.handleError(e)
            })
        );
    }

    handleError(error: any) {
        this.decrementRequestCount();
        return throwError(error);
    };

    decrementRequestCount() {
        if (--this.currentRequests == 0) {
            this._auth.checkLoading(false);
        }
    }

    incrementRequestCount() {
        if (this.currentRequests++ == 0) {
            this._auth.checkLoading(true);
        }
    }
}
